<template>
  <div class="header p-4 text-white" :class="{'is-logged': user}">
    <div v-if="user" class="logout">
      <img @click="Logout" src="@/assets/images/logout.png" alt />
    </div>
    <div v-if="user">
      <p class="logo">Superspace</p>
      <div class="greeting flex items-baseline mt-4">
        <h1 class="greeting__user">Hello {{ user }}</h1>
      </div>
    </div>
    <div v-else>
      <p class="logo">Superspace</p>
      <h1 class="mt-16">Connexion</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    user: {
      required: false,
    },
  },
  methods: {
    Logout() {
      this.$emit("logout");
    },
  },
};
</script>



<style lang="scss" scoped>
.logout {
  img {
    transform-origin: top right;
    transform: scale(0.5);

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
